import ImageModal from './modal'
import Example from './stackedLayouts'
import stackedLayouts from './stackedLayouts'
export default function App() {
  return (
    <Example/>
  )
}